// Never derived from the value: a partial mask still reveals part of it.
export const MASKED_VALUE = "********";

export const canViewMaskedFields = (userConfig: any): boolean =>
  userConfig?.payload?.role?.name === "admin" ||
  userConfig?.payload?.allowed_permissions?.view_masked_fields !== undefined;

// A rule on a masked property is read-only for users who cannot view masked fields.
export const isMaskedFieldLocked = (fieldName: string | undefined, context: any): boolean => {
  if (!fieldName || context?.canViewMaskedFields !== false) return false;
  return context?.fields?.find((field: any) => field?.name === fieldName)?.masked === true;
};

export const hasLockedRule = (ruleOrGroup: any, context: any): boolean =>
  Array.isArray(ruleOrGroup?.rules)
    ? ruleOrGroup.rules.some((rule: any) => hasLockedRule(rule, context))
    : isMaskedFieldLocked(ruleOrGroup?.field, context);
